import { http, requestBlob } from '../client';
import type { CallOptions, WriteOptions } from '../types';
import type { EinvoiceApi } from './einvoice';

// Paths mirror subsystems/commerce/facade/adapters/admin-api/src/admin/einvoice.rs.
const seg = encodeURIComponent;
const rd = (o?: CallOptions) => ({ signal: o?.signal });
const wr = (o?: WriteOptions) => ({ signal: o?.signal, idempotencyKey: o?.idempotencyKey, notifyCustomer: o?.notifyCustomer });

export const einvoiceHttp: EinvoiceApi = {
  getInvoiceEInvoices: (invoiceId, opts) => http.get('api', `/commerce/invoices/${seg(invoiceId)}/einvoice`, rd(opts)),
  createInvoiceEInvoice: (invoiceId, opts) => http.post('api', `/commerce/invoices/${seg(invoiceId)}/einvoice`, {}, wr(opts)),
  issueEInvoice: (id, opts) => http.post('api', `/einvoices/${seg(id)}/issue`, {}, wr(opts)),
  reconcileEInvoice: (id, opts) => http.post('api', `/einvoices/${seg(id)}/reconcile`, {}, wr(opts)),
  refreshEInvoiceBuyer: (id, opts) => http.post('api', `/einvoices/${seg(id)}/refresh-buyer`, {}, wr(opts)),
  refreshEInvoiceStatus: (id, opts) => http.post('api', `/einvoices/${seg(id)}/status`, {}, wr(opts)),
  downloadEInvoice: (id, file, opts) => requestBlob('api', `/einvoices/${seg(id)}/download`, { file }, opts?.signal),
  proposeEInvoiceChange: (id, body, opts) => http.post('api', `/einvoices/${seg(id)}/changes`, body, wr(opts)),
  executeEInvoiceChange: (approvalRequestId, opts) => http.post('api', `/einvoices/changes/${seg(approvalRequestId)}/execute`, {}, wr(opts)),
  withdrawEInvoice: (id, body, opts) => http.post('api', `/einvoices/${seg(id)}/withdraw`, body, wr(opts)),
};
